/**
 * @generated SignedSource<<08a21e8943a61a879459e2eb6f565b56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgendaGeneratorPreviewMutation$variables = {
  noteId: string;
  purpose?: string | null;
};
export type AgendaGeneratorPreviewMutation$data = {
  readonly generateAgenda: {
    readonly agenda: any;
  } | null;
};
export type AgendaGeneratorPreviewMutation = {
  response: AgendaGeneratorPreviewMutation$data;
  variables: AgendaGeneratorPreviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "purpose"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "purpose",
        "variableName": "purpose"
      }
    ],
    "concreteType": "GenerateAgenda",
    "kind": "LinkedField",
    "name": "generateAgenda",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "agenda",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgendaGeneratorPreviewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgendaGeneratorPreviewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d0e44dd1b7b63c688d4b9cc86a7203a5",
    "id": null,
    "metadata": {},
    "name": "AgendaGeneratorPreviewMutation",
    "operationKind": "mutation",
    "text": "mutation AgendaGeneratorPreviewMutation(\n  $noteId: ID!\n  $purpose: String\n) {\n  generateAgenda(noteId: $noteId, purpose: $purpose) {\n    agenda\n  }\n}\n"
  }
};
})();

(node as any).hash = "12e960a0ca5d64192a47a03c2a556ba2";

export default node;
